import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import './SupervisaoAtivos.scss';

class SupervisaoAtivos extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>
            Supervisão da precificação de ativos e da distribuição de cotas de fundos - Iniciativas - {texts.title}
          </title>
        </Helmet>

        <div
          className="iniciativas-home supervisao-ativos-home page-gradient page-gradient--yellow bg-gray"
          ref="supervisao-ativos-home"
        >
          <section className="iniciativas-area supervisao-ativos-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title title--gray">
                            Supervisão da precificação de ativos <br className="br_desk" />e da distribuição de cotas de
                            fundos
                          </h1>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Iniciamos duas novas supervisões: a da precificação de ativos feita pelos administradores
                            dos fundos regulados pela Instrução CVM 555 e a da atividade de distribuição de cotas de
                            fundos. Os resultados são sempre compartilhados com a CVM, otimizando o trabalho da
                            autarquia, que pode utilizá-los para fazer novas averiguações ou atuar com uma instituição,
                            caso seja necessário.
                          </p>
                          <p>Veja os resultados de 2019:</p>
                        </div>
                      </div>
                      {/* <div className="card__image">
                        <img src={images.iniciativas.raio_x.capa} />
                      </div> */}
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="iniciativas-body supervisao-ativos-body">
            <div className="container container--large">
              <div className="row">
                <div className="col-4">
                  <Fade bottom>
                    <div className="card card--no-border card--precificacao">
                      <div className="card__content card__content--full">
                        <div className="card__content__header">
                          <h3 className="title title--small yellow">Supervisão de precificação</h3>
                        </div>
                        <div className="card__content__body">
                          <div className="rows">
                            <div className="line" style={{ borderTop: 'none' }}>
                              <p>
                                análise de <b className="yellow">312</b> fundos que resultou em
                              </p>
                            </div>

                            <div className="line">
                              <h3>65</h3>
                              <p>
                                questionamentos <br />
                                às instituições
                              </p>
                            </div>

                            <div className="line">
                              <h3>18</h3>
                              <p>
                                cartas <br />
                                de orientação
                              </p>
                            </div>

                            <div className="line">
                              <h3>3</h3>
                              <p>
                                PAIs <span>(Procedimento para Apuração de Irregularidades)</span>
                              </p>
                            </div>

                            <div className="line">
                              <h3>1</h3>
                              <p>
                                termos de <br />
                                compromisso
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4">
                  <Fade bottom>
                    <div className="card card--no-border card--supervisao">
                      <div className="card__content card__content--full">
                        <div className="card__content__header">
                          <h3 className="title title--small yellow">
                            Supervisão de distribuição <br className="br_desk" />
                            de produtos de investimento
                          </h3>
                        </div>
                        <div className="card__content__body">
                          <div className="rows" style={{ marginTop: '0px' }}>
                            <div className="line" style={{ borderTop: 'none' }}>
                              <p>Análise de:</p>
                            </div>
                          </div>
                          <div className="columns row">
                            <div className="col-4">
                              <h3>115</h3>
                              <p>fundos</p>
                            </div>

                            <div className="col-4">
                              <h3>292</h3>
                              <p>aplicações</p>
                            </div>

                            <div className="col-4">
                              <h3>42</h3>
                              <p>
                                agentes
                                <br />
                                autônomos
                              </p>
                            </div>
                          </div>

                          <div className="rows">
                            <div className="line" style={{ borderTop: 'none' }}>
                              <p>que resultaram em:</p>
                            </div>

                            <div className="line">
                              <h3>127</h3>
                              <p>questionamentos</p>
                            </div>

                            <div className="line">
                              <h3>32</h3>
                              <p>
                                cartas <br />
                                de orientação
                              </p>
                            </div>

                            <div className="line">
                              <h3>19</h3>
                              <p>
                                apontamentos <br />
                                <small>(itens que não cumpriam o código)</small>
                              </p>
                            </div>

                            <div className="line">
                              <h3>5</h3>
                              <p>
                                PAIs <br />
                                <small>(Procedimento para Apuração de Irregularidades)</small>
                              </p>
                            </div>

                            <div className="line">
                              <h3>1</h3>
                              <p>processo</p>
                            </div>

                            <div className="line">
                              <h3>2</h3>
                              <p>
                                termos de <br />
                                compromisso
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4">
                  <Fade bottom>
                    <div className="card card--no-border">
                      <div className="card__content card__content--full">
                        <div className="card__content__body">
                          <p>
                            As novidades fazem parte do convênio firmado com a autarquia, em 2018, para aproveitamento
                            da autorregulação de fundos.
                          </p>
                          <p>
                            A primeira fase da parceria, posta em prática em setembro do ano de lançamento, contempla a
                            análise prévia, pela Associação, dos pedidos de habilitação para administradores de
                            carteiras de valores mobiliários feitos à CVM. Desde o lançamento, foram aprovados mais de
                            247 pedidos de pessoas físicas e 61 pedidos de pessoas jurídicas.
                          </p>
                          <img src={images.iniciativas.supervisao_ativos.icones} className="grafico_ativos" />
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { SupervisaoAtivos };
